module.exports = __webpack_public_path__ + "static/media/join-bg.1451b589.jpg";